import { createTheme, MantineThemeOverride, MantineColorsTuple } from '@mantine/core';

// 1. Royal Indigo
const royalIndigo: MantineColorsTuple = [
  '#f5f0ff',
  '#e6d9ff',
  '#ceb3ff',
  '#b48cff',
  '#9a66ff',
  '#8A2BE2',
  '#7B26CC',
  '#6B21B6',
  '#5B1CA0',
  '#4B0082',
];

// 2. Sunset Citrus
const sunsetCitrus: MantineColorsTuple = [
  '#fff5f0',
  '#ffe6d9',
  '#ffccb3',
  '#ffb28c',
  '#ff9966',
  '#FF7E00',
  '#FF5C00',
  '#FF3A00',
  '#FF1A1A',
  '#E60000',
];

// 3. Deep Ocean Calm
const deepOcean: MantineColorsTuple = [
  '#e6f4f9',
  '#cce9f3',
  '#89C2D9',
  '#61A5C2',
  '#468FAF',
  '#2A6F97',
  '#1E6091',
  '#155080',
  '#013A63',
  '#012A4A',
];

// 4. Sage & Sand
const sageSand: MantineColorsTuple = [
  '#f5f5f4',
  '#e6e6e4',
  '#d4d4d1',
  '#C9C0B8',
  '#b3a99f',
  '#9d9486',
  '#87806d',
  '#687466',
  '#5a6859',
  '#4d5c4d',
];

// 5. Neon Candy
const neonCandy: MantineColorsTuple = [
  '#fff0fe',
  '#ffe0fd',
  '#ffb3fb',
  '#ff80f9',
  '#FF00EA',
  '#E600D2',
  '#CC00BB',
  '#66E5FF',
  '#33EEFF',
  '#00F0FF',
];

// 6. Luxury Plum
const luxuryPlum: MantineColorsTuple = [
  '#f9e6ff',
  '#f2ccff',
  '#E1A6F2',
  '#C147E9',
  '#A935D8',
  '#810CA8',
  '#6B0990',
  '#550778',
  '#3F0560',
  '#2D033B',
];

// 7. Soft Sunrise
const softSunrise: MantineColorsTuple = [
  '#fffcff',
  '#FFF8FF',
  '#FFD1FF',
  '#FFCCF5',
  '#FFDDCC',
  '#FFE4C4',
  '#FFF0B3',
  '#FFF8B8',
  '#FFFACC',
  '#FFFCE6',
];

// 8. Warm Stone
const warmStone: MantineColorsTuple = [
  '#f7f7f7',
  '#E3E3E3',
  '#D1D1D1',
  '#BFBFBF',
  '#A6A6A6',
  '#8C8C8C',
  '#737373',
  '#5C5C5C',
  '#454545',
  '#2E2E2E',
];

// 9. Wine & Gold
const wineGold: MantineColorsTuple = [
  '#fff9e6',
  '#FFD700',
  '#E6C300',
  '#CCB000',
  '#B58392',
  '#9A6E7F',
  '#7F5A6C',
  '#644559',
  '#5A0F2E',
  '#4A0D26',
];

// 10. Cherry Blossom
const cherryBlossom: MantineColorsTuple = [
  '#fff5f8',
  '#FFDBE9',
  '#FFD1E6',
  '#FFC7E3',
  '#FFB7C5',
  '#FFA7B5',
  '#FF97A5',
  '#FF8795',
  '#FF7785',
  '#FF6775',
];

// 11. Forest Light
const forestLight: MantineColorsTuple = [
  '#e6fff0',
  '#ccffe0',
  '#99ffc2',
  '#66ffa3',
  '#4CAF50',
  '#43A047',
  '#388E3C',
  '#2E7D32',
  '#1E5631',
  '#145223',
];

// 12. Arctic Night
const arcticNight: MantineColorsTuple = [
  '#e6f2ff',
  '#cce5ff',
  '#99ccff',
  '#66b3ff',
  '#3399ff',
  '#00509E',
  '#003D7A',
  '#002B56',
  '#001F4D',
  '#001433',
];

// 13. Metal & Fire
const metalFire: MantineColorsTuple = [
  '#f7f7f7',
  '#D4D4D4',
  '#BBBBBB',
  '#A2A2A2',
  '#888888',
  '#6F6F6F',
  '#565656',
  '#444444',
  '#333333',
  '#222222',
];

// 14. Creamy Pastel
const creamyPastel: MantineColorsTuple = [
  '#FFFFFF',
  '#FFF8F5',
  '#FFD1A9',
  '#FFE0C9',
  '#FFC3E1',
  '#FFD6EC',
  '#C5E4FF',
  '#9EC8FF',
  '#D3FFD2',
  '#9FFF8F',
];

// 15. Royal Blue & Copper
const royalBlueCopper: MantineColorsTuple = [
  '#e6f0ff',
  '#cce0ff',
  '#99c2ff',
  '#66a3ff',
  '#3385ff',
  '#0056D2',
  '#004BB8',
  '#003F9E',
  '#003087',
  '#002570',
];

// 16. Mint & Orchid
const mintOrchid: MantineColorsTuple = [
  '#e6fff5',
  '#ccffeb',
  '#99ffd6',
  '#66ffc2',
  '#29FFA5',
  '#00D084',
  '#00B872',
  '#00A060',
  '#00884E',
  '#00703C',
];

// 17. Flamingo Beach
const flamingoBeach: MantineColorsTuple = [
  '#fff0f5',
  '#FFC1DE',
  '#FFB0D2',
  '#FF9FC6',
  '#FF8EBA',
  '#FF5E9A',
  '#FF4E8A',
  '#FF3E7A',
  '#FF2E6A',
  '#FF1E5A',
];

// 18. Nordic Frost
const nordicFrost: MantineColorsTuple = [
  '#F1FCFF',
  '#E6F9FF',
  '#CCF3FF',
  '#B3EDFF',
  '#A1D6E2',
  '#8BC9D8',
  '#75BCCE',
  '#5FAFC4',
  '#49A2BA',
  '#3395B0',
];

// 19. Autumn Harvest
const autumnHarvest: MantineColorsTuple = [
  '#fff5f0',
  '#ffe6d9',
  '#ffccb3',
  '#ffb28c',
  '#E85D04',
  '#D85000',
  '#C84400',
  '#B83800',
  '#A82C00',
  '#9C2C00',
];

// 20. Sahara Dusk
const saharaDusk: MantineColorsTuple = [
  '#fff8f0',
  '#E8AE68',
  '#DFA05E',
  '#D69254',
  '#CD844A',
  '#BA7C2A',
  '#A86E24',
  '#96601E',
  '#845218',
  '#724412',
];

// 21. Emerald Mist
const emeraldMist: MantineColorsTuple = [
  '#e6fff5',
  '#ccffeb',
  '#99ffd6',
  '#66ffc2',
  '#2DD3A5',
  '#22C896',
  '#17BD87',
  '#0CB278',
  '#009970',
  '#008862',
];

// 22. Industrial Neon
const industrialNeon: MantineColorsTuple = [
  '#f0f0f0',
  '#d9d9d9',
  '#b3b3b3',
  '#8c8c8c',
  '#666666',
  '#434343',
  '#363636',
  '#292929',
  '#1C1C1C',
  '#0f0f0f',
];

// 23. Twilight Lavender
const twilightLavender: MantineColorsTuple = [
  '#f5f0f5',
  '#e6dce6',
  '#d4c4d4',
  '#c2acc2',
  '#B56576',
  '#A25869',
  '#8F4B5C',
  '#7C3E4F',
  '#6D597A',
  '#5A4A65',
];

// 24. Candy Peach
const candyPeach: MantineColorsTuple = [
  '#fff8f5',
  '#FFDAC1',
  '#FFD0B3',
  '#FFC6A5',
  '#FFBC97',
  '#FF9A76',
  '#FF8A66',
  '#FF7A56',
  '#FF6A46',
  '#FF5A36',
];

// 25. Crimson Ice
const crimsonIce: MantineColorsTuple = [
  '#fff0f2',
  '#ffe0e4',
  '#ffc2c9',
  '#ffa3ad',
  '#FF5C6A',
  '#F04E5C',
  '#E1404E',
  '#D72638',
  '#C81D2E',
  '#B91424',
];

// 26. Storm & Honey
const stormHoney: MantineColorsTuple = [
  '#f0f2f5',
  '#dce1e8',
  '#b9c3d0',
  '#96A5B8',
  '#6C7B8B',
  '#5A6979',
  '#485767',
  '#364555',
  '#2E4057',
  '#243345',
];

// 27. Jade Dynasty
const jadeDynasty: MantineColorsTuple = [
  '#e6fff7',
  '#ccffef',
  '#99ffdf',
  '#66ffcf',
  '#2BBFA5',
  '#1FB596',
  '#13AB87',
  '#07A178',
  '#057D65',
  '#046B56',
];

// 28. Frosted Blueberry
const frostedBlueberry: MantineColorsTuple = [
  '#f0e6ff',
  '#e0ccff',
  '#c299ff',
  '#a366ff',
  '#7B2CBF',
  '#6A24A8',
  '#591C91',
  '#48147A',
  '#3A0CA3',
  '#2D0880',
];

// 29. Cosmic Prism
const cosmicPrism: MantineColorsTuple = [
  '#f0f5ff',
  '#e0ebff',
  '#c1d6ff',
  '#a3c2ff',
  '#7597DE',
  '#5A7ED0',
  '#4065C2',
  '#2B4CB4',
  '#2B1055',
  '#200D40',
];

// 30. Art Deco Elegance
const artDecoElegance: MantineColorsTuple = [
  '#e6f2f5',
  '#cce5eb',
  '#99ccd6',
  '#66b3c2',
  '#3399ad',
  '#135E8C',
  '#0F5078',
  '#0B4264',
  '#0B3954',
  '#072B40',
];

// 31. Neural Electric (BONUS)
const neuralElectric: MantineColorsTuple = [
  '#f0e6ff',
  '#e0ccff',
  '#c299ff',
  '#AF72FF',
  '#9F62FF',
  '#8F52FF',
  '#7F42FF',
  '#6F32FF',
  '#6A00FF',
  '#5A00E6',
];

// 32. Lava Ember (BONUS)
const lavaEmber: MantineColorsTuple = [
  '#fff0f0',
  '#ffe0e0',
  '#ffc2c2',
  '#ffa3a3',
  '#E32A00',
  '#CC2500',
  '#B52000',
  '#9E1B00',
  '#871600',
  '#7C0000',
];

// 33. Fresh Herb Garden (BONUS)
const freshHerbGarden: MantineColorsTuple = [
  '#e6fff0',
  '#B7E4C7',
  '#A3D9B6',
  '#8FCEA5',
  '#7BC394',
  '#4CAF50',
  '#43A047',
  '#388E3C',
  '#2E7D32',
  '#1B5E20',
];

// 34. Vanilla Sky (BONUS)
const vanillaSky: MantineColorsTuple = [
  '#FFFFFF',
  '#FFFDF8',
  '#FFF1D0',
  '#FFEBC9',
  '#FFE5C2',
  '#FFDFBB',
  '#FFD9B4',
  '#FFD3AD',
  '#FFCDA6',
  '#FFC79F',
];

// 35. Mystic Portal (BONUS)
const mysticPortal: MantineColorsTuple = [
  '#f0e6ff',
  '#e0ccff',
  '#c299ff',
  '#a366ff',
  '#6B00B6',
  '#5E00A0',
  '#51008A',
  '#440074',
  '#30006E',
  '#250058',
];

// Gradient definition with optional via color
export interface GradientDef {
  from: string;
  to: string;
  via?: string;
  deg?: number;
}

// Color scheme configurations with full gradient support
export interface ColorScheme {
  key: string;
  label: string;
  emoji: string;
  primary: GradientDef;
  secondary: GradientDef;
  tertiary: GradientDef;
  primaryColor: string;
  isDark?: boolean;
}

export const colorSchemes: ColorScheme[] = [
  // 1. Royal Indigo
  {
    key: 'royal-indigo',
    label: 'Royal Indigo',
    emoji: '🪄',
    primary: { from: '#4B0082', to: '#8A2BE2', deg: 135 },
    secondary: { from: '#00C896', to: '#40E0D0', deg: 135 },
    tertiary: { from: '#FFD700', to: '#FFF3B0', deg: 135 },
    primaryColor: 'royalIndigo',
  },
  // 2. Sunset Citrus
  {
    key: 'sunset-citrus',
    label: 'Sunset Citrus',
    emoji: '🌅',
    primary: { from: '#FF7E00', to: '#FF1A1A', deg: 135 },
    secondary: { from: '#00E5FF', to: '#1A9FFF', deg: 135 },
    tertiary: { from: '#6A0DAD', to: '#AD3EFF', deg: 135 },
    primaryColor: 'sunsetCitrus',
  },
  // 3. Deep Ocean Calm
  {
    key: 'deep-ocean',
    label: 'Deep Ocean Calm',
    emoji: '🌊',
    primary: { from: '#013A63', to: '#89C2D9', via: '#2A6F97', deg: 135 },
    secondary: { from: '#E2C48E', to: '#F1E6C9', deg: 135 },
    tertiary: { from: '#FF6F59', to: '#FF9E80', deg: 135 },
    primaryColor: 'deepOcean',
  },
  // 4. Sage & Sand
  {
    key: 'sage-sand',
    label: 'Sage & Sand',
    emoji: '🌿',
    primary: { from: '#687466', to: '#C9C0B8', deg: 135 },
    secondary: { from: '#6A7FDB', to: '#A7B1FF', deg: 135 },
    tertiary: { from: '#D07F55', to: '#EDB79C', deg: 135 },
    primaryColor: 'sageSand',
  },
  // 5. Neon Candy
  {
    key: 'neon-candy',
    label: 'Neon Candy',
    emoji: '💜🧪',
    primary: { from: '#FF00EA', to: '#00F0FF', deg: 135 },
    secondary: { from: '#D4FF00', to: '#9FFF00', deg: 135 },
    tertiary: { from: '#FF5A00', to: '#FF9F00', deg: 135 },
    primaryColor: 'neonCandy',
  },
  // 6. Luxury Plum
  {
    key: 'luxury-plum',
    label: 'Luxury Plum',
    emoji: '👑',
    primary: { from: '#2D033B', to: '#C147E9', via: '#810CA8', deg: 135 },
    secondary: { from: '#1ABC9C', to: '#5BE3C4', deg: 135 },
    tertiary: { from: '#E9C891', to: '#FFF1D0', deg: 135 },
    primaryColor: 'luxuryPlum',
    isDark: true,
  },
  // 7. Soft Sunrise
  {
    key: 'soft-sunrise',
    label: 'Soft Sunrise',
    emoji: '🌤',
    primary: { from: '#FFD1FF', to: '#FFE4C4', via: '#FFF8B8', deg: 135 },
    secondary: { from: '#D1E0FF', to: '#A5C8FF', deg: 135 },
    tertiary: { from: '#A9FFD4', to: '#D5FFED', deg: 135 },
    primaryColor: 'softSunrise',
  },
  // 8. Warm Stone
  {
    key: 'warm-stone',
    label: 'Warm Stone',
    emoji: '🪨',
    primary: { from: '#5C5C5C', to: '#E3E3E3', via: '#A6A6A6', deg: 135 },
    secondary: { from: '#9E6D49', to: '#C49A72', deg: 135 },
    tertiary: { from: '#7C8A55', to: '#ADBF84', deg: 135 },
    primaryColor: 'warmStone',
  },
  // 9. Wine & Gold
  {
    key: 'wine-gold',
    label: 'Wine & Gold',
    emoji: '🍷',
    primary: { from: '#5A0F2E', to: '#FFD700', via: '#B58392', deg: 135 },
    secondary: { from: '#1E5631', to: '#4CAF50', deg: 135 },
    tertiary: { from: '#74C0FC', to: '#C5E4FF', deg: 135 },
    primaryColor: 'wineGold',
    isDark: true,
  },
  // 10. Cherry Blossom
  {
    key: 'cherry-blossom',
    label: 'Cherry Blossom',
    emoji: '🌸',
    primary: { from: '#FFB7C5', to: '#FFDBE9', deg: 135 },
    secondary: { from: '#9CFFE6', to: '#C9FFF2', deg: 135 },
    tertiary: { from: '#FFE1A8', to: '#FFDDB0', deg: 135 },
    primaryColor: 'cherryBlossom',
  },
  // 11. Forest Light
  {
    key: 'forest-light',
    label: 'Forest Light',
    emoji: '🌲',
    primary: { from: '#1E5631', to: '#4CAF50', deg: 135 },
    secondary: { from: '#F2BB05', to: '#F4D35E', deg: 135 },
    tertiary: { from: '#4B7BEC', to: '#82AFFF', deg: 135 },
    primaryColor: 'forestLight',
  },
  // 12. Arctic Night
  {
    key: 'arctic-night',
    label: 'Arctic Night',
    emoji: '❄️',
    primary: { from: '#001F4D', to: '#00509E', deg: 135 },
    secondary: { from: '#FFB703', to: '#FFDD57', deg: 135 },
    tertiary: { from: '#27EB83', to: '#A3FFC9', deg: 135 },
    primaryColor: 'arcticNight',
    isDark: true,
  },
  // 13. Metal & Fire
  {
    key: 'metal-fire',
    label: 'Metal & Fire',
    emoji: '⚙️🔥',
    primary: { from: '#444444', to: '#D4D4D4', via: '#888888', deg: 135 },
    secondary: { from: '#FF4500', to: '#FF8B3D', deg: 135 },
    tertiary: { from: '#00E0B8', to: '#7BFFD1', deg: 135 },
    primaryColor: 'metalFire',
  },
  // 14. Creamy Pastel
  {
    key: 'creamy-pastel',
    label: 'Creamy Pastel',
    emoji: '🍨',
    primary: { from: '#FFD1A9', to: '#FFC3E1', deg: 135 },
    secondary: { from: '#9EC8FF', to: '#C5E4FF', deg: 135 },
    tertiary: { from: '#9FFF8F', to: '#D3FFD2', deg: 135 },
    primaryColor: 'creamyPastel',
  },
  // 15. Royal Blue & Copper
  {
    key: 'royal-blue-copper',
    label: 'Royal Blue & Copper',
    emoji: '⚓',
    primary: { from: '#003087', to: '#0056D2', deg: 135 },
    secondary: { from: '#D38235', to: '#E6B78A', deg: 135 },
    tertiary: { from: '#76EEC6', to: '#C9FFE6', deg: 135 },
    primaryColor: 'royalBlueCopper',
    isDark: true,
  },
  // 16. Mint & Orchid
  {
    key: 'mint-orchid',
    label: 'Mint & Orchid',
    emoji: '🌱',
    primary: { from: '#00D084', to: '#29FFA5', deg: 135 },
    secondary: { from: '#A13DE6', to: '#D691FF', deg: 135 },
    tertiary: { from: '#FFD966', to: '#FFF0BD', deg: 135 },
    primaryColor: 'mintOrchid',
  },
  // 17. Flamingo Beach
  {
    key: 'flamingo-beach',
    label: 'Flamingo Beach',
    emoji: '🦩',
    primary: { from: '#FF5E9A', to: '#FFC1DE', deg: 135 },
    secondary: { from: '#71C9CE', to: '#AFFBFF', deg: 135 },
    tertiary: { from: '#FFE66D', to: '#FFF3B0', deg: 135 },
    primaryColor: 'flamingoBeach',
  },
  // 18. Nordic Frost
  {
    key: 'nordic-frost',
    label: 'Nordic Frost',
    emoji: '🧊',
    primary: { from: '#A1D6E2', to: '#F1FCFF', deg: 135 },
    secondary: { from: '#FFAD60', to: '#FFD2A7', deg: 135 },
    tertiary: { from: '#8E7CC3', to: '#C3B6E2', deg: 135 },
    primaryColor: 'nordicFrost',
  },
  // 19. Autumn Harvest
  {
    key: 'autumn-harvest',
    label: 'Autumn Harvest',
    emoji: '🍂',
    primary: { from: '#9C2C00', to: '#E85D04', deg: 135 },
    secondary: { from: '#5B8E7D', to: '#9BD2BE', deg: 135 },
    tertiary: { from: '#F4E285', to: '#FDEAB6', deg: 135 },
    primaryColor: 'autumnHarvest',
  },
  // 20. Sahara Dusk
  {
    key: 'sahara-dusk',
    label: 'Sahara Dusk',
    emoji: '🐪',
    primary: { from: '#BA7C2A', to: '#E8AE68', deg: 135 },
    secondary: { from: '#326273', to: '#6CAFB8', deg: 135 },
    tertiary: { from: '#C255A8', to: '#F1A9E0', deg: 135 },
    primaryColor: 'saharaDusk',
  },
  // 21. Emerald Mist
  {
    key: 'emerald-mist',
    label: 'Emerald Mist',
    emoji: '💎',
    primary: { from: '#009970', to: '#2DD3A5', deg: 135 },
    secondary: { from: '#FF3B61', to: '#FF8AA2', deg: 135 },
    tertiary: { from: '#FFC233', to: '#FFE292', deg: 135 },
    primaryColor: 'emeraldMist',
  },
  // 22. Industrial Neon
  {
    key: 'industrial-neon',
    label: 'Industrial Neon',
    emoji: '⚡',
    primary: { from: '#1C1C1C', to: '#434343', deg: 135 },
    secondary: { from: '#39FF14', to: '#A4FF6F', deg: 135 },
    tertiary: { from: '#14B3FF', to: '#6ED1FF', deg: 135 },
    primaryColor: 'industrialNeon',
    isDark: true,
  },
  // 23. Twilight Lavender
  {
    key: 'twilight-lavender',
    label: 'Twilight Lavender',
    emoji: '🌌',
    primary: { from: '#6D597A', to: '#B56576', deg: 135 },
    secondary: { from: '#3C91E6', to: '#89C5FF', deg: 135 },
    tertiary: { from: '#FFD23F', to: '#FFE78F', deg: 135 },
    primaryColor: 'twilightLavender',
  },
  // 24. Candy Peach
  {
    key: 'candy-peach',
    label: 'Candy Peach',
    emoji: '🍑',
    primary: { from: '#FF9A76', to: '#FFDAC1', deg: 135 },
    secondary: { from: '#94D1BE', to: '#C9F5EA', deg: 135 },
    tertiary: { from: '#C3B1E1', to: '#E5DAFF', deg: 135 },
    primaryColor: 'candyPeach',
  },
  // 25. Crimson Ice
  {
    key: 'crimson-ice',
    label: 'Crimson Ice',
    emoji: '❄️🔥',
    primary: { from: '#D72638', to: '#FF5C6A', deg: 135 },
    secondary: { from: '#29A3FF', to: '#95D3FF', deg: 135 },
    tertiary: { from: '#19FF87', to: '#9FFFCC', deg: 135 },
    primaryColor: 'crimsonIce',
  },
  // 26. Storm & Honey
  {
    key: 'storm-honey',
    label: 'Storm & Honey',
    emoji: '⛈🧈',
    primary: { from: '#2E4057', to: '#6C7B8B', deg: 135 },
    secondary: { from: '#E9A13C', to: '#FFD789', deg: 135 },
    tertiary: { from: '#59C9A5', to: '#A4EBDD', deg: 135 },
    primaryColor: 'stormHoney',
    isDark: true,
  },
  // 27. Jade Dynasty
  {
    key: 'jade-dynasty',
    label: 'Jade Dynasty',
    emoji: '🐉',
    primary: { from: '#057D65', to: '#2BBFA5', deg: 135 },
    secondary: { from: '#F2545B', to: '#FF969B', deg: 135 },
    tertiary: { from: '#FFD23F', to: '#FFF3A1', deg: 135 },
    primaryColor: 'jadeDynasty',
  },
  // 28. Frosted Blueberry
  {
    key: 'frosted-blueberry',
    label: 'Frosted Blueberry',
    emoji: '🫐',
    primary: { from: '#3A0CA3', to: '#7B2CBF', deg: 135 },
    secondary: { from: '#30D5C8', to: '#8FF6E9', deg: 135 },
    tertiary: { from: '#F1B814', to: '#FFE57C', deg: 135 },
    primaryColor: 'frostedBlueberry',
    isDark: true,
  },
  // 29. Cosmic Prism
  {
    key: 'cosmic-prism',
    label: 'Cosmic Prism',
    emoji: '🌠',
    primary: { from: '#2B1055', to: '#7597DE', deg: 135 },
    secondary: { from: '#11C1FF', to: '#7ADFEE', deg: 135 },
    tertiary: { from: '#FF3E55', to: '#FF99A5', deg: 135 },
    primaryColor: 'cosmicPrism',
    isDark: true,
  },
  // 30. Art Deco Elegance
  {
    key: 'art-deco-elegance',
    label: 'Art Deco Elegance',
    emoji: '🏛',
    primary: { from: '#0B3954', to: '#135E8C', deg: 135 },
    secondary: { from: '#E08E45', to: '#F1C38E', deg: 135 },
    tertiary: { from: '#66CDAA', to: '#A3FFE4', deg: 135 },
    primaryColor: 'artDecoElegance',
    isDark: true,
  },
  // BONUS SCHEMES (31-35)
  // 31. Neural Electric
  {
    key: 'neural-electric',
    label: 'Neural Electric',
    emoji: '🧠',
    primary: { from: '#6A00FF', to: '#AF72FF', deg: 135 },
    secondary: { from: '#00FFC3', to: '#82FFE7', deg: 135 },
    tertiary: { from: '#FFEE33', to: '#FFF6A4', deg: 135 },
    primaryColor: 'neuralElectric',
  },
  // 32. Lava Ember
  {
    key: 'lava-ember',
    label: 'Lava Ember',
    emoji: '🌋',
    primary: { from: '#7C0000', to: '#E32A00', deg: 135 },
    secondary: { from: '#FFC300', to: '#FFE382', deg: 135 },
    tertiary: { from: '#0044A0', to: '#4E94FF', deg: 135 },
    primaryColor: 'lavaEmber',
    isDark: true,
  },
  // 33. Fresh Herb Garden
  {
    key: 'fresh-herb-garden',
    label: 'Fresh Herb Garden',
    emoji: '🪴',
    primary: { from: '#4CAF50', to: '#B7E4C7', deg: 135 },
    secondary: { from: '#FF7A5C', to: '#FFB8A8', deg: 135 },
    tertiary: { from: '#4D9FFF', to: '#C2E5FF', deg: 135 },
    primaryColor: 'freshHerbGarden',
  },
  // 34. Vanilla Sky
  {
    key: 'vanilla-sky',
    label: 'Vanilla Sky',
    emoji: '🧁',
    primary: { from: '#FFF1D0', to: '#FFEBC9', deg: 135 },
    secondary: { from: '#AECBFA', to: '#D2E6FF', deg: 135 },
    tertiary: { from: '#C3F1C8', to: '#E2FFEA', deg: 135 },
    primaryColor: 'vanillaSky',
  },
  // 35. Mystic Portal
  {
    key: 'mystic-portal',
    label: 'Mystic Portal',
    emoji: '🔮',
    primary: { from: '#30006E', to: '#6B00B6', deg: 135 },
    secondary: { from: '#14FFE3', to: '#A3FFF5', deg: 135 },
    tertiary: { from: '#FFDD33', to: '#FFF6A8', deg: 135 },
    primaryColor: 'mysticPortal',
    isDark: true,
  },
];

// Legacy accent colors for backward compatibility
export const accentColors = {
  indigo: { label: 'Indigo', color: 'indigo' },
  teal: { label: 'Teal', color: 'teal' },
  orange: { label: 'Orange', color: 'orange' },
  pink: { label: 'Pink', color: 'pink' },
  cyan: { label: 'Cyan', color: 'cyan' },
  violet: { label: 'Violet', color: 'violet' },
  grape: { label: 'Grape', color: 'grape' },
  red: { label: 'Red', color: 'red' },
  green: { label: 'Green', color: 'green' },
  blue: { label: 'Blue', color: 'blue' },
  yellow: { label: 'Yellow', color: 'yellow' },
  lime: { label: 'Lime', color: 'lime' },
};

// Semantic gradients for UI components
export const semanticGradients = {
  primary: { from: '#5B21FF', to: '#9F7AEA', deg: 135 },
  secondary: { from: '#0EA5E9', to: '#22C55E', deg: 135 },
  tertiary: { from: '#F97316', to: '#FACC15', deg: 135 },
  success: { from: '#16A34A', to: '#4ADE80', deg: 135 },
  info: { from: '#0284C7', to: '#0EA5E9', deg: 135 },
  warning: { from: '#F59E0B', to: '#FACC15', deg: 135 },
  danger: { from: '#DC2626', to: '#FB7185', deg: 135 },
};

// Helper to generate CSS gradient string
export function getGradientStyle(gradient: GradientDef): string {
  const deg = gradient.deg ?? 135;
  if (gradient.via) {
    return `linear-gradient(${deg}deg, ${gradient.from}, ${gradient.via}, ${gradient.to})`;
  }
  return `linear-gradient(${deg}deg, ${gradient.from}, ${gradient.to})`;
}

// Get primary gradient style from color scheme
export function getPrimaryGradient(scheme: ColorScheme): string {
  return getGradientStyle(scheme.primary);
}

// Get secondary gradient style from color scheme
export function getSecondaryGradient(scheme: ColorScheme): string {
  return getGradientStyle(scheme.secondary);
}

// Get tertiary gradient style from color scheme
export function getTertiaryGradient(scheme: ColorScheme): string {
  return getGradientStyle(scheme.tertiary);
}

// Get color scheme by key
export function getColorScheme(key: string): ColorScheme | undefined {
  return colorSchemes.find((scheme) => scheme.key === key);
}

// Default color scheme
export const defaultColorScheme = colorSchemes[0]; // Royal Indigo

export const radiusScale = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '24px',
};

/**
 * Z-index scale for consistent layering across components.
 * Use these instead of arbitrary z-index values.
 *
 * @example
 * import { zIndexScale } from '@/theme';
 * style={{ zIndex: zIndexScale.modal }}
 */
export const zIndexScale = {
  /** Behind content (e.g., background patterns) */
  behind: -1,
  /** Default layer for content */
  base: 0,
  /** Floating elements like dropdowns */
  dropdown: 100,
  /** Sticky elements like headers */
  sticky: 200,
  /** Fixed elements like navigation */
  fixed: 300,
  /** Drawer/Sidebar components */
  drawer: 400,
  /** Modal/Dialog overlays */
  modal: 500,
  /** Popover components */
  popover: 600,
  /** Tooltip components */
  tooltip: 700,
  /** Toast/Notification components */
  toast: 800,
  /** Spotlight/Command palette */
  spotlight: 900,
  /** Maximum z-index for critical overlays */
  max: 9999,
} as const;

/**
 * Responsive breakpoints matching Mantine's default breakpoints.
 * Use these for consistent responsive design.
 *
 * @example
 * import { breakpoints, useMediaQuery } from '@/theme';
 * const isMobile = useMediaQuery(`(max-width: ${breakpoints.sm})`);
 *
 * // Or in CSS-in-JS
 * style={{
 *   width: '100%',
 *   [`@media (min-width: ${breakpoints.md})`]: { width: '50%' }
 * }}
 */
export const breakpoints = {
  /** Extra small (mobile): 576px */
  xs: '576px',
  /** Small (large phones): 768px */
  sm: '768px',
  /** Medium (tablets): 992px */
  md: '992px',
  /** Large (desktops): 1200px */
  lg: '1200px',
  /** Extra large (large desktops): 1408px */
  xl: '1408px',
} as const;

/**
 * Breakpoint values as numbers (in pixels) for calculations
 */
export const breakpointValues = {
  xs: 576,
  sm: 768,
  md: 992,
  lg: 1200,
  xl: 1408,
} as const;

/**
 * Media query helpers for responsive styles
 *
 * @example
 * import { mediaQueries } from '@/theme';
 *
 * const styles = {
 *   [mediaQueries.up.md]: { display: 'flex' },
 *   [mediaQueries.down.sm]: { display: 'block' },
 * };
 */
export const mediaQueries = {
  /** Min-width media queries (mobile-first) */
  up: {
    xs: `@media (min-width: ${breakpoints.xs})`,
    sm: `@media (min-width: ${breakpoints.sm})`,
    md: `@media (min-width: ${breakpoints.md})`,
    lg: `@media (min-width: ${breakpoints.lg})`,
    xl: `@media (min-width: ${breakpoints.xl})`,
  },
  /** Max-width media queries (desktop-first) */
  down: {
    xs: `@media (max-width: ${breakpointValues.xs - 1}px)`,
    sm: `@media (max-width: ${breakpointValues.sm - 1}px)`,
    md: `@media (max-width: ${breakpointValues.md - 1}px)`,
    lg: `@media (max-width: ${breakpointValues.lg - 1}px)`,
    xl: `@media (max-width: ${breakpointValues.xl - 1}px)`,
  },
  /** Between breakpoints */
  between: {
    xsAndSm: `@media (min-width: ${breakpoints.xs}) and (max-width: ${breakpointValues.sm - 1}px)`,
    smAndMd: `@media (min-width: ${breakpoints.sm}) and (max-width: ${breakpointValues.md - 1}px)`,
    mdAndLg: `@media (min-width: ${breakpoints.md}) and (max-width: ${breakpointValues.lg - 1}px)`,
    lgAndXl: `@media (min-width: ${breakpoints.lg}) and (max-width: ${breakpointValues.xl - 1}px)`,
  },
} as const;

export const elevationScale = {
  none: 'none',
  xs: '0 1px 2px rgba(15, 23, 42, 0.06)',
  sm: '0 1px 3px rgba(15, 23, 42, 0.08)',
  md: '0 4px 12px rgba(15, 23, 42, 0.12)',
  lg: '0 12px 32px rgba(15, 23, 42, 0.16)',
  xl: '0 18px 48px rgba(15, 23, 42, 0.18)',
};

// Separate elevation scales for dark mode (stronger shadows on black background)
export const elevationScaleDark = {
  none: 'none',
  xs: '0 1px 2px rgba(0, 0, 0, 0.4)',
  sm: '0 1px 3px rgba(0, 0, 0, 0.5)',
  md: '0 4px 12px rgba(0, 0, 0, 0.6)',
  lg: '0 12px 32px rgba(0, 0, 0, 0.7)',
  xl: '0 18px 48px rgba(0, 0, 0, 0.8)',
};

export const typographyRoles = {
  display: { fontSize: '42px', lineHeight: '1.2', fontWeight: 700 },
  headline: { fontSize: '28px', lineHeight: '1.25', fontWeight: 650 },
  title: { fontSize: '22px', lineHeight: '1.3', fontWeight: 600 },
  subtitle: { fontSize: '18px', lineHeight: '1.35', fontWeight: 600 },
  body: { fontSize: '16px', lineHeight: '1.6', fontWeight: 400 },
  bodySmall: { fontSize: '15px', lineHeight: '1.55', fontWeight: 400 },
  label: { fontSize: '14px', lineHeight: '1.45', fontWeight: 600 },
  caption: { fontSize: '13px', lineHeight: '1.4', fontWeight: 500 },
};

export const semanticColors = {
  light: {
    text: {
      primary: '#000000',      // Pure black (main text)
      secondary: '#1a1a1a',    // Slight black variant (10% lighter)
      muted: '#333333',        // Muted text (20% lighter)
      mostMuted: '#666666',    // Most muted (40% lighter)
      inverted: '#ffffff',     // For dark backgrounds
    },
    surface: {
      base: '#f8f8f8',        // AppShell background
      subtle: '#f8f8f8',      // Same as base
      raised: '#ffffff',      // Cards, Modals, Menus (foreground)
    },
    border: {
      subtle: '#e5e5e5',      // Soft border (90% lightness)
      strong: '#cccccc',      // Stronger border (80% lightness)
    },
    states: {
      info: '#0ea5e9',
      success: '#22c55e',
      warning: '#f59e0b',
      danger: '#ef4444',
    },
  },
  dark: {
    text: {
      primary: '#ffffff',      // Pure white (main text)
      secondary: '#f0f0f0',    // Slight white variant (6% darker)
      muted: '#cccccc',        // Muted text (20% darker)
      mostMuted: '#999999',    // Most muted (40% darker)
      inverted: '#000000',     // For light backgrounds
    },
    surface: {
      base: '#000000',        // AppShell background (PURE BLACK)
      subtle: '#000000',      // Same as base
      raised: '#202020',      // Cards, Modals, Menus (foreground)
    },
    border: {
      subtle: '#282828',      // rgb(40, 40, 40)
      strong: '#282828',      // rgb(40, 40, 40)
    },
    states: {
      info: '#38bdf8',
      success: '#34d399',
      warning: '#fbbf24',
      danger: '#f87171',
    },
  },
};

export const appTheme: MantineThemeOverride = createTheme({
  primaryColor: 'indigo',
  fontFamily:
    'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  defaultRadius: 'md',
  // WCAG compliant font sizes
  fontSizes: {
    xs: '14px', // Captions/Labels
    sm: '15px', // Small body text
    md: '16px', // Base body text (WCAG minimum)
    lg: '18px', // Large body text
    xl: '20px', // Extra large body
  },
  // WCAG compliant line heights (1.5 minimum for body text)
  lineHeights: {
    xs: '1.4',
    sm: '1.5',
    md: '1.6',
    lg: '1.65',
    xl: '1.7',
  },
  // WCAG compliant heading sizes
  headings: {
    fontWeight: '600',
    sizes: {
      h1: { fontSize: '42px', lineHeight: '1.2' },
      h2: { fontSize: '28px', lineHeight: '1.25' },
      h3: { fontSize: '22px', lineHeight: '1.3' },
      h4: { fontSize: '18px', lineHeight: '1.35' },
      h5: { fontSize: '16px', lineHeight: '1.4' },
      h6: { fontSize: '14px', lineHeight: '1.4' },
    },
  },
  colors: {
    royalIndigo,
    sunsetCitrus,
    deepOcean,
    sageSand,
    neonCandy,
    luxuryPlum,
    softSunrise,
    warmStone,
    wineGold,
    cherryBlossom,
    forestLight,
    arcticNight,
    metalFire,
    creamyPastel,
    royalBlueCopper,
    mintOrchid,
    flamingoBeach,
    nordicFrost,
    autumnHarvest,
    saharaDusk,
    emeraldMist,
    industrialNeon,
    twilightLavender,
    candyPeach,
    crimsonIce,
    stormHoney,
    jadeDynasty,
    frostedBlueberry,
    cosmicPrism,
    artDecoElegance,
    neuralElectric,
    lavaEmber,
    freshHerbGarden,
    vanillaSky,
    mysticPortal,
    // Override Mantine's dark palette for new color scheme
    dark: [
      '#f5f5f5',  // dark[0] - lightest
      '#e5e5e5',  // dark[1]
      '#cccccc',  // dark[2]
      '#b3b3b3',  // dark[3]
      '#999999',  // dark[4]
      '#666666',  // dark[5]
      '#202020',  // dark[6] - Our foreground color (Cards, Modals, Menus)
      '#101010',  // dark[7]
      '#0a0a0a',  // dark[8]
      '#000000',  // dark[9] - Pure black (AppShell background)
    ],
  },
  other: {
    accents: accentColors,
    gradients: semanticGradients,
    colorSchemes,
    radiusScale,
    elevation: elevationScale,
    elevationDark: elevationScaleDark,
    typography: typographyRoles,
    semanticColors,
  },
  components: {
    Button: {
      styles: (theme: MantineThemeOverride) => ({
        root: {
          '&.gradientPrimary': {
            backgroundImage: `linear-gradient(135deg, ${semanticGradients.primary.from}, ${semanticGradients.primary.to})`,
            color: '#fff',
            '&:hover': {
              opacity: 0.9,
            },
          },
          '&.gradientSuccess': {
            backgroundImage: `linear-gradient(135deg, ${semanticGradients.success.from}, ${semanticGradients.success.to})`,
            color: '#fff',
            '&:hover': {
              opacity: 0.9,
            },
          },
          '&.gradientDanger': {
            backgroundImage: `linear-gradient(135deg, ${semanticGradients.danger.from}, ${semanticGradients.danger.to})`,
            color: '#fff',
            '&:hover': {
              opacity: 0.9,
            },
          },
          '&.gradientWarning': {
            backgroundImage: `linear-gradient(135deg, ${semanticGradients.warning.from}, ${semanticGradients.warning.to})`,
            color: '#fff',
            '&:hover': {
              opacity: 0.9,
            },
          },
          '&.gradientInfo': {
            backgroundImage: `linear-gradient(135deg, ${semanticGradients.info.from}, ${semanticGradients.info.to})`,
            color: '#fff',
            '&:hover': {
              opacity: 0.9,
            },
          },
          '&.gradientSecondary': {
            backgroundImage: `linear-gradient(135deg, ${semanticGradients.secondary.from}, ${semanticGradients.secondary.to})`,
            color: '#fff',
            '&:hover': {
              opacity: 0.9,
            },
          },
        },
      }),
    },
  },
});
